import React from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';

const fixterSvgBin = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="14px"
    height="16px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <g>
          <rect
            x="3.5"
            y="3.5"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            width="16"
            height="20"
          />

          <rect
            x="7.5"
            y="0.5"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            width="8"
            height="3"
          />

          <line
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            x1="1"
            y1="3.5"
            x2="23"
            y2="3.5"
          />

          <line
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            x1="7.5"
            y1="7"
            x2="7.5"
            y2="19"
          />

          <line
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            x1="11.5"
            y1="7"
            x2="11.5"
            y2="19"
          />

          <line
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            x1="15.5"
            y1="7"
            x2="15.5"
            y2="19"
          />
        </g>
      </g>
      <g />
    </g>
    <g>
      <rect fill="none" width="24" height="24" />
    </g>
  </svg>
);

export default props => <LegacyIcon component={fixterSvgBin} {...props} />;
